<template>
  <div class="QA">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/productList' }">产品列表</el-breadcrumb-item>
      <el-breadcrumb-item>QA问答库</el-breadcrumb-item>
    </el-breadcrumb>
    <p class="title">
      <span>问答库配置</span>
      <span style="margin-left:10px;">
        <el-button type="success" size="mini" @click="dialogFormVisible = true"><i class="el-icon-upload"></i> 批量导入</el-button>
         <el-button type="primary" size="mini" @click="addList"><i class="el-icon-plus"></i> 添加</el-button>
      </span>
      <span style="position: absolute;right:30px">
         <el-button type="primary" size="mini" :loading="asyncLoad" :disabled="asyncFlag" @click="qa_async">同步到智能硬件</el-button>
      </span>

    </p>
<div class="qa_list">
  <template>
    <div>
      <table style="margin-bottom: -1px;border: 1px solid #ebeef5;border-bottom:none;" class="table text-center">
        <thead>
        <tr>
          <th class="text-center" style="width: 40%;">
            问句
            <el-tooltip placement="top">
              <div slot="content">问句是问答库中常用典型问法，系统会自动将您的常见问句做泛化处理，<br/>当用户命中问句时，系统会从对应答句中召回一条返回给用户</div>
              <i class="icon iconfont icon-wenhao blurIcon"></i>
            </el-tooltip>
          </th>
          <th class="text-center" style="width: 40%;">
            答句
            <el-tooltip placement="top">
              <div slot="content">答句是问答库中常用典型答案，智能硬件会根据您定义<br/>的答句中随机抽取一条作为答案返回给用户</div>
              <i class="icon iconfont icon-wenhao blurIcon"></i>
            </el-tooltip>
          </th>
          <th style="width: 20%;" class="text-center">操作</th>
        </tr>
        <tr v-for="(item, index) in tableData">
          <td class="text-center">
            <ul class="qa_item" v-if="item.status == 1">
              <li v-for="em in item.question">{{em}}</li>
            </ul>
            <el-input
                    :id="'question'+index"
                    type="textarea"
                    :rows="5"
                    placeholder="请输入问句"
                    :value="item.question.join(`\n`)"
                    v-if="item.status == 0"
            >
            </el-input>
          </td>
          <td class="text-center">
            <ul class="qa_item" v-if="item.status == 1">
              <li v-for="em in item.answer">{{em}}</li>
            </ul>
            <el-input
                    v-if="item.status == 0"
                    :id="'answer'+index"
                    type="textarea"
                    :rows="5"
                    placeholder="请输入答句"
                    :value="item.answer.join(`\n`)"
            >
            </el-input>
          </td>
          <td class="text-center">
            <el-button type="text" size="mini" @click="qa_save(index)"v-if="item.status == 0">保存</el-button>
            <el-button type="text" size="mini" @click="changeList(index)" v-if="item.status == 1">编辑</el-button>
            <el-button type="text" size="mini" @click="deleteItem(index)" v-if="item.status == 1">删除</el-button>
            <el-button type="text" size="mini" @click="cancelItem(index)" v-if="item.status == 0">取消</el-button>
          </td>
        </tr>
        </thead>
      </table>
    </div>
    <el-dialog
            title="删除"
            :visible.sync="dialogVisible"
            width="30%">
      <span>确定要删除这条问答吗?</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="removeList">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
            title="批量导入"
            :visible.sync="dialogFormVisible"
            @close="closeUpload"
            width="40%"
            >
      <el-upload class="fileUpLoad"
                 id="fileUpLoad"
                 :action="uploadUrl()"
                 :show-file-list="false"
                 :on-success="handleFileSuccess"
                 :before-upload="beforeFileUpload"
                 :on-error="failUpload"
      >
        <el-button type="primary" size="mini">导入语料库文件</el-button>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大小不要超过10M</span>
      </el-upload>
      <!--<el-upload class="fileUpLoad"-->
                 <!--id="fileUpLoad"-->
                 <!--:action="conAddress()"-->
                 <!--:data="impData"-->
                 <!--name="qa_file"-->
                 <!--:show-file-list="false"-->
                 <!--:on-success="handleFileSuccess"-->
                 <!--:before-upload="beforeFileUpload"-->
                 <!--:on-error="failUpload"-->
                <!--&gt;-->
        <!--<el-button type="primary" size="mini">导入语料库文件</el-button>-->
        <!--<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大小不要超过10M</span>-->
      <!--</el-upload>-->
      <br>
      <p class="filePrompt">导入CSV 格式的词库文件,只支持utf8编码,内容格式请参考：
        <a href="http://dlbcdn.update.ainirobot.com/open/oriontalk_sample.csv" download="template.csv"><span class='muban'>语料库模板.csv</span></a>
      </p>
       	<div class='grey' v-show="impF">
          <span style="color:#67c23a">导入成功:</span>
          <span> 总条数:{{impMessage.count_num}}条</span>
          <span> 成功:{{impMessage.success_num}}条</span>
          <span> 失败:{{impMessage.fail_num}}条</span>
          <span> 重复:{{impMessage.repeat_num}}条</span>
        </div>
      <!--<div class='grey' v-show='filename'><span style="color:#67c23a">导入成功:</span>{{filename}}</div>-->

        <!--<el-button @click="dialogFormVisible = false">取 消</el-button> -->
        <!--<el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>-->
    </el-dialog>
  </template>
</div>
    <div class="block">
      <el-pagination
              v-show="page.total > 20"
              :current-page="page.current_page"
              layout="prev, pager, next"
              :total="page.total"
              :page-size="page.per_page"
              prev-text="上一页"
              next-text="下一页"
              @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
   import axios from 'axios'
  import qs from 'qs'
   import config from '@/config/index'
  import {qaSave, qaList, qaDelete, qaSync, qaFileImport} from '@/api/hardIndex.js'
  import {getUserId} from '@/api'

  export default {
    mixins: [],
    data() {
      return {
          tableData: [
              // {
              //   question: ['今天天气怎么样', '阿佛昵图网'],
              //     answer: ['挺好的', '还可以'],
              //     status: 1
              // }
          ],
          user_id: '',
          dialogVisible: false, // 删除本组
          dialogFormVisible: false, // 批量导入
          index: null, // 删除时用到
          filename: '',
          c_page: 1,
          page: {},
          impData: {}, // 上传文件时的参数
          asyncLoad: false,
          impMessage: {},
          impF: false, // 导入成功后显示
          asyncFlag: true // 同步到智能硬件 在保存和删除后才可以false点击
      };
    },

    created() {
        this.getUserId()
    },
      watch: {
          tableData : function () {
              if (this.tableData.length == 0) {
                  this.tableData = [];
                  this.tableData.unshift({
                      question: [],
                      answer: [],
                      status: 0
                  })
              }
          }
      },
    methods: {
        uploadUrl() {//动态写入图片地址
            return `${config.host}/user/upload`
        },
        // 区分环境改变上传地址
        conAddress () {
            return window.location.host.includes('open.ainirobot.com') ? 'http://admin.ovs.ainirobot.com/api/skill/qaImport' : 'http://118.89.228.66:8090/api/skill/qaImport'
        },
        // 关闭上传弹框
        closeUpload () {
            this.impF = false
            this.impMessage = {}

        },
        async qa_list (page = 1, isUpload) {
            let data = {
                user_id: this.user_id,
                client_id: this.$route.query.client_id,
                page: page
            }
           let res = await qaList(JSON.stringify(data))
            if (res.data.code == 200) {
                if (isUpload == 'upload') {
                    setTimeout(() => {
                        this.dialogFormVisible = false // 上传成功，获取列表是关闭弹框
                    }, 3000)
                }
                this.page = res.data.params.page
                this.tableData = []
                res.data.data.forEach(item => {
                    item.status = 1
                    this.tableData.push(item)
                })
            } else {
                this.$message.error('获取问答数据失败')
            }
        },
        async getUserId() {//获取用户id skillId
            let res = await getUserId()
            this.user_id = res.data.data.id
            this.qa_list()
        },
        // 单条保存
        async qa_save (index) {
            if ($('#question' + index).val() == '' || $('#answer'+index).val() == '') {
                return
            }
            let reg = /\n{1,}/g;
            let question_arr = $('#question'+index).val().replace(reg, ',').split(',')

            for (let i = 0; i < question_arr.length; i++) {
                const item = question_arr[i];
                if (item.length > 20) { // 问句不能大于20个字符
                    this.$message.warning('每条问句不超过20个字符，支持中英文')
                    return
                }
            }
          this.tableData[index].question = question_arr
          this.tableData[index].answer = $('#answer'+index).val().replace(reg, ',').split(',')
            if (!this.tableData[index].question[0]) {
                this.tableData[index].question.shift()
            }
            if (!this.tableData[index].answer[0]) {
                this.tableData[index].answer.shift()
            }
            if (!this.tableData[index].question[this.tableData[index].question.length - 1]) {
                this.tableData[index].question.pop()
            }
            if (!this.tableData[index].answer[this.tableData[index].answer.length - 1]) {
                this.tableData[index].answer.pop()
            }
            let data = {
                user_id: this.user_id,
                client_id: this.$route.query.client_id,
                qa_id:  this.tableData[index].qa_id ? this.tableData[index].qa_id : '',
                question: this.tableData[index].question,
                answer: this.tableData[index].answer
            }
            let res = await qaSave(JSON.stringify(data))
           if (res.data.code == 200) {
               // this.tableData[index].status = 1
               // this.tableData[index] = res.data.data
               // this.tableData[index].client_id = this.$route.query.client_id
               this.asyncFlag = false // 同步到智能硬件 在保存和删除后才可以false点击
               if (this.tableData[index].qa_id) {
                   this.qa_list(this.c_page)
               } else {
                   this.qa_list()
               }
           } else {
                this.$message.error('保存失败')
           }

        },
        mapTableData (data) { // 编辑和添加时 遍历数组 改变状态为1列表list
            if (!data) {
                // data 为空，添加问答，将所有状态变为1
                this.tableData.forEach(item => {
                    item.status = 1
                })
            }
            for (let i = 0; i < this.tableData.length; i++) {
                const item = this.tableData[i];
                if (item == data) {
                    item.status = 0
                } else {
                    item.status = 1
                    if (item.question.length == 0 && item.answer.length == 0) {
                        this.tableData.splice(i, 1)
                        i--
                    }
                }
            }
        },
        changeList (index) { // 编辑每一组问答
            let data = this.tableData[index]
            this.mapTableData(data)
      },
        deleteItem (index) {
            this.dialogVisible = true
            this.index = index
        },
        // 取消添加/编辑
        cancelItem (index) {
            if (this.tableData[index].question.length == 0 && this.tableData[index].answer.length == 0) {
                if (this.tableData.length == 1) {
                    $('#question'+index).val('')
                    $('#answer'+index).val('')
                } else {
                    this.tableData.splice(index,1)
                }
                return
            }
            this.tableData[index].status = 1
        },
        // 确定删除
        async removeList () {
            let data = {
                user_id: this.user_id,
                client_id: this.$route.query.client_id,
                qa_id:  this.tableData[this.index].qa_id,
            }
            let res = await qaDelete(JSON.stringify(data))
            if (res.data.code == 200) {
                this.asyncFlag = false // 同步到智能硬件 在保存和删除后才可以false点击
                this.$message.success('删除成功')
                if (this.tableData.length == 1 && this.c_page > 1) { // 当删除掉最有一条问答时，请求 当前页-1 的数据
                    this.qa_list(this.c_page -1)
                } else {
                    this.qa_list(this.c_page)
                }
            } else {
                this.$message.error('删除失败')
            }
            // this.tableData.splice(this.index, 1)
            this.dialogVisible = false
        },
        // 添加一行新的问答
        addList () {
            if (this.tableData.length) {
                if (this.tableData[0].status == 0) {
                    return
                }
            }
            this.mapTableData()
            this.tableData.unshift({
                    question: [],
                    answer: [],
                    status: 0
                })


        },
        // 点击页码
        changePage: function (page) {
            this.c_page = page
            this.qa_list(this.c_page)
        },
        // 同步到智能硬件
        async qa_async () {
            this.asyncLoad = true
            let data = {
                user_id: this.user_id,
                client_id: this.$route.query.client_id
            }
            let res =  await qaSync(JSON.stringify(data))
            if (res.data.code == 200) {
                this.asyncFlag = true // 同步到智能硬件 后不可点击
                this.$message.success('同步成功，请稍等几分钟后进行测试')
            } else {
                if (res.data.errors.data) {
                    this.$message.error(res.data.errors.data)
                } else {
                    this.$message.error('同步失败')
                }
            }
            this.asyncLoad = false
        },
        // 上传成功
        handleFileSuccess(res, file) {
            if (res.code == 200) {
                this.impData = {
                    user_id: this.user_id,
                    client_id: this.$route.query.client_id,
                    qa_file: res.data.url
                }
                this.qa_file_import()
            } else {
                this.$message.error('抱歉，批量导入失败，请检查文件格式及网络状况后重试')
                this.dialogFormVisible = false // 上传失败，关闭弹框
            }
        },
        async qa_file_import () {
            let res = await qaFileImport(this.impData)
            if (res.data.code == 200) {
                this.asyncFlag = false // 同步到智能硬件 在保存和删除后才可以false点击
                this.impMessage = res.data.data
                this.impF = true
                this.qa_list(1,'upload')
            } else {
                if (res.data.errors.data) {
                    this.$message.error(res.data.errors.data)
                } else {
                    this.$message.error('抱歉，批量导入失败，请检查文件格式及网络状况后重试')
                }
                this.dialogFormVisible = false // 上传失败，关闭弹框
            }
        },
        // 上传之前
        beforeFileUpload (file) {
            var fileSize = 0;
            if (file.size > 1024 * 1024) {
                var Size = Math.round(file.size * 100 / (1024 * 1024)) / 100;
                if (Size > 10) {
                    this.$alert('文件不能大于10M', '温馨提示', {});
                    return false;
                }
                fileSize = (Math.round(file.size * 100 / (1024 * 1024)) / 100).toString() + 'MB';
            } else {
                fileSize = (Math.round(file.size * 100 / 1024) / 100).toString() + 'KB';
            }
            if (file.type !== 'text/csv' && file.type !== 'application/vnd.ms-excel') {
                this.$alert('请上传csv的格式文件', '温馨提示', {});
                return false;
            }
            if (file) {
                this.filename = file.name
            }
        },
        failUpload (err, file, fileList) {
            console.log(err)
            console.log(file)
            console.log(fileList)
        }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
.QA{
  background-color: #fff;
  .title {
    height: 64px;
    line-height: 64px;
    padding-left: 30px;
    font-size: 16px;
    font-weight: 800;
    color: #2e4d79;
    border-bottom: 1px solid #f5f5f5;
    border-left: 2px solid #010202;
  }
  .qa_list{
    padding:10px 30px;
    .blurIcon {
      color: #7abaf1;
    }
    .table>thead>tr{
      border:1px solid #dcdfe6;
      &:hover{
        background:#f7f7f7;
      }
    }
    .table>thead>tr>td{
      vertical-align: middle;
      border:1px solid #dcdfe6;
      textarea{
        font-weight: 400;
      }
      .qa_item{
        padding:10px 10px 10px 30px;
        width: 100%;
        height: 100%;
        li{
          text-align: left;
        }
      }
    }
    .table>thead>tr>th{
      background:#f9fafc;
      border:1px solid #dcdfe6;
    }

  }

  .block {
    text-align: right;
    padding: 10px 20px 20px 0 ;
    .el-pagination {
      button,
      li {
        background-color: transparent;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hardware/pro/QA.vue